/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { Button } from 'ui/components/common';
import { useAdminParams } from 'utils/helpers';
import { Notification } from 'utils/types';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';

const BookingDescription = {
  BOOKING_APPOINTMENT: ({ meta }: Notification) => {
    const { startAt, guests } = meta as Record<string, any>;

    const __guests: string[] = [];

    for (let i = 0; i < guests?.length; i++) {
      const { firstName, lastName } = guests[i];

      if (guests.length === i + 2) {
        __guests.push(`${firstName} ${lastName}`);
        __guests.push(' and ');
      } else if (guests.length > i) {
        __guests.push(`${firstName} ${lastName}`);

        if (guests.length !== i + 1) __guests.push(', ');
      } else {
        __guests.push(`${firstName} ${lastName}`);
        __guests.push(' ');
      }
    }

    const _dateTime = dayjs(startAt);

    // eslint-disable-next-line max-len
    return `${__guests.join('')} booked an appointment with you on ${_dateTime?.format('YYYY-MM-DD') ?? 'YYYY-MM-DD'} at ${_dateTime?.format('HH:mm A') ?? 'HH:mm AA'}.`;
  },
};

const BookingLogs = {
  BOOKING_APPOINTMENT: {
    title: 'Booking Appointment',
    description: (_n?: Notification) =>
      BookingDescription.BOOKING_APPOINTMENT(_n as Notification),
    element: (notification: Notification) => {
      const {
        state: { isPreview },
      } = useAppWrapperContext();
      const { meta, referenceId } = notification;

      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (!isPreview)
          return `/calendar/calendar?selectedEvent=${referenceId}`;

        // eslint-disable-next-line max-len
        return `/preview/accounts/${accountId}/users/${accountUserId}/calendar/calendar?selectedEvent=${referenceId}`;
      }, [isPreview, accountId, accountUserId, referenceId]);

      const event = useMemo(() => meta?.title ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {BookingDescription['BOOKING_APPOINTMENT'](notification)}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Event Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={event}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
};

export default BookingLogs;
